import AirdropBalance from "@/components/layout/airdrop/AirdropBalance";
import WillReceive from "@/components/layout/airdrop/WillReceive";
import SuccessfulClaimedAirdrop from "@/components/layout/modal/SuccessfulClaimedAirdrop";
import WithdrawalError from "@/components/layout/modal/WithdrawalError";
import ConnectedWallet from "@/components/layout/settings/ConnectedWallet";
import ConnectedWalletMeBASE from "@/components/layout/withdraw/ConnectedWalletMeBASE";
import { useAirdropValueStore } from "@/modules/airdrop/store/value";
import { useUserStore } from "@/modules/auth/store/user";
import {
  useModalSuccessfulAirdropStore,
} from "@/shared/store/modal";

const Airdrop = () => {
  const { airdrop, airdropBASE, tonPrice, price } = useUserStore();

  const { isOpen, isOpenError, closeModal, closeModalError } =
    useModalSuccessfulAirdropStore();

  const toBTN = (tonAmount: number) => {
    if (!tonPrice || !price) return 0;
    return (tonAmount * tonPrice) / price;
  };

  const airdropWithFee = airdrop.ton - (airdrop.fee || 0);

  const { currentToken, net } = useAirdropValueStore();

  return (
    <>
      <div className="flex flex-col justify-between items-center gap-3 px-4 pb-40">
        {net === "ton" ? <ConnectedWallet /> : <ConnectedWalletMeBASE />}

        <AirdropBalance />

        <WillReceive />
      </div>

      {isOpen && (
        <SuccessfulClaimedAirdrop
          amount={
            net === "base"
              ? airdropBASE.token
              : currentToken === "token" || currentToken === ""
              ? toBTN(airdrop.ton)
              : airdropWithFee
          }
          onClose={closeModal}
        />
      )}

      {isOpenError && <WithdrawalError onClose={closeModalError} />}
    </>
  );
};

export default Airdrop;
